<script>
    import Common from "../common/index";
    import * as commonServer from "../../../../../../api/common";

    export default {
        name: "youxi",
        mixins: [Common],
        watch: {
            show:{
                handler(vl) {
                    if (vl) {
                        this.init()
                    }
                },
                deep: true,
                immediate: true
            },
            '$store.state.curClassType':{
                handler(){
                    this.flashData()
                },
                deep: true
            },
            search: {
                handler(){
                    this.searching()
                },
                deep: true
            },
            selectCatalog: {
                handler(){
                    this.searching()
                },
                deep: true
            }
        },
        computed: {
            getGameCategoryTree(){
                return this.isPlat?'getGameCategoryTreeDouble':'getGameCategoryTree'
            },
            getGameList(){
                return this.isPlat?'getGameList':'getGameList'
            },
            catalogType() {
                return this.isPlat?'double_teacher':'client'
            },
            getFormList(){
                return this.isPlat?'getFormList':'getFormList'
            },
        },
        data(){
            return {
                cacheData: {}, // 缓存请求服务端相同参数
                fn: null,
                searchData: [], // 搜索内容
                selectCatalog: '', // 当前选中的目录
                catalogData: null, // 目录内容
                search: '',
                type: 'game',
                gameType: '', // 游戏类型 线上|线下｜双师
                config: [
                    {
                        type: 'SearchBox',
                        value: '',
                        fixed: true
                    },
                    {
                        type: 'TypeBtn',
                        value: '',
                        selected: '2',
                        form: [
                            {key: '2', value: '公共游戏'},
                            // {key: '1', value: '我的游戏'},
                        ],
                        fixed: true
                    },
                    {
                        type: 'CatalogType',
                        isFilter: true,
                        filterValue: '',
                        value: '',
                        selected: '',
                        fixed: true
                    },
                    {
                        type: 'TypeList',
                        form: [
                            // {
                            //     title: '游戏效果1',
                            //     data: [
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: true},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //     ],
                            //     column: 3,
                            // },
                            // {
                            //     title: '游戏效果2',
                            //     data: [
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: true},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //         {url: this.$images.contents.datu, love: false},
                            //     ],
                            //     column: 3,
                            // },
                        ],
                        selected: [0]
                    },
                    {
                        type: 'SearchList',
                        value: ''
                    },
                    {
                        type: 'MoreBtn',
                        value: ''
                    },
                ]
            }
        },
        created(){
            if(this.practiceBool()){
                this.gameType='is_exercise';
            }
        },
        methods:{
            // init(){
            //     this.flashData()
            // },
            // 正在搜索
            practiceBool(){
                return `${this.$route.query.is_practice}` === 'true'
            },
            searching(){
                clearTimeout(this.fn)
                this.fn = setTimeout(()=>{
                    if(!this.selectCatalog && !this.search){
                        return false
                    }
                    this.getSearchData({perPage: 9999, gtype: 'io'})
                },300)
            },
            async flashData(initial){
                this.isLoading = true
                let index = this.getIndexByType('TypeList')
                // 获取所有的游戏一级目录
                const res = await commonServer.default[this.getGameCategoryTree]({
                    clientsId: this.$store.state.initConfig.school_id
                })
                //console.log('获取游戏列表分类[youxi]==>', res.data)

                // 获取分类
                this.catalogData = res.data.filter(v=>v.io_count > 0)

                this.config[index].selected = []
                this.config[index].form = res.data.filter(v=>v.parent_id === 0 && v.io_count > 0).map(q=>{
                    return {
                        title: q.name,
                        column: 2,
                        data: [],
                        ...q,
                    }
                })

                let obj = {}
                this.config[index].form.map(async (v,i)=>{
                    obj = {
                        clientsId: this.$store.state.initConfig.school_id,
                        categoryId: v.id,
                        // classType: this.$store.state.curClassType,
                        gameType: this.gameType,
                        gtype: 'io',
                        is_push: this.isPlat?1:0
                    }
                    if (this.search) {
                        obj.search = this.search
                    }

                    // 数据请求地址 & 参数
                    v.apiConfig = {
                        params: obj,
                        request: commonServer.default[this.getGameList]
                    }

                    if(i===0) {
                        // 设置默认选中分类 (图片默认场景图分类，动画默认人物分类，游戏默认选择题分类)
                        let defaultSelectedType = ''
                        let indexCatalogType = -1
                        this.config.map((v, i)=>{
                            if(v.type === 'CatalogType'){
                                indexCatalogType = i
                            }
                        })
                        this.config[index].form.map(v=>{
                            if(['选择题'].includes(v.title)){
                                defaultSelectedType = v.id
                            }
                        })
                        if(defaultSelectedType && !initial){
                            obj.categoryId = defaultSelectedType
                            this.selectCatalog = defaultSelectedType
                            this.config[indexCatalogType].selected = defaultSelectedType
                        }

                        let data = await commonServer.default.getGameList(obj)
                        // 需要获取 所有游戏对应的场景
                        let arr = data.items.map(q => {
                            return {
                                url: q.cover,
                                ...q
                            }
                        })
                        let newArr = []
                        let resScene
                        for(let i = 0, len = arr.length; i < len; i++) {
                            let obj = {
                                page: 1,
                                categoryId: arr[i].form_category_id_scenes,
                                perPage: 16
                            }
                            // 缓存相同表单依赖
                            if(this.cacheData[JSON.stringify(obj)]) {
                                resScene = this.cacheData[JSON.stringify(obj)]
                            } else {
                                //resScene = await commonServer.default[this.getFormList](obj)
                                resScene=arr[i].form_category_scenes_list;
                                this.cacheData[JSON.stringify(obj)] = resScene
                            }
                            resScene.map(q=>{
                                newArr.push({
                                    ...arr[i],
                                    form_id_scenes: q.id,
                                    alias: `${arr[i].alias}-${q.name}`,
                                    url: this.getImg(q.options)
                                })
                            })
                            v.page = data.meta.current_page
                            v.last_page = data.meta.last_page
                        }
                        v.data = newArr

                        // 如果第一个数据有值默认选中第一个展开
                        if(v.data && v.data.length>0) {
                            this.config[index].selected = [i]
                        }
                    }
                    this.navTypesData = this.config[index].form
                })
                const fn = setTimeout(()=>{
                    this.isLoading = false
                    clearTimeout(fn)
                }, 10000)
            },
            // 根据游戏配置获取图片
            getImg(str) {
                let url = ''
                try {
                    let obj = JSON.parse(str)
                    // console.log(obj)
                    // debugger
                    obj.layout.map(v=>{
                        if(v.config && v.config[0].attr === 'cover'){
                            url = v.config[0].value
                        }
                    })
                }catch (e) {
                    console.log('等待获取背景图==>', e)
                }
                return url
            },
            onSearchBox(search){
                this.search = search
                // this.flashData()
            },

            // 获取搜索数据
            async getSearchData({perPage, ...params}) {
                
                this.isLoading = true
                let list = []
                try {
                    let obj = {
                        perPage,
                        page: 1,
                        // classType: this.$store.state.curClassType,
                        is_push: this.isPlat?1:0,
                        gameType: this.gameType,
                        ...params
                    }
                    if (this.selectCatalog) obj.categoryId = this.selectCatalog
                    if (this.search) obj.search = this.search
                    let newObj = this.getCurObj(obj)

                    let getList = this.getResourceList
                    if(this.type === 'game')getList = 'getGameList'
                    let data = await commonServer.default[getList](newObj)

                    if(this.type === 'game') {
                        // 游戏搜索，必须关联出所有场景
                        let newArr = []
                        let resScene
                        let arr = data.items
                        for(let i = 0, len = arr.length; i < len; i++) {
                            /*resScene = await commonServer.default[this.getFormList]({
                                page: 1,
                                categoryId: arr[i].form_category_id_scenes,
                                perPage: 99
                            })*/
                            resScene=arr[i].form_category_scenes_list;
                            resScene.map(q=>{
                                newArr.push({
                                    ...arr[i],
                                    form_id_scenes: q.id,
                                    alias: `${arr[i].alias}-${q.name}`,
                                    url: this.getImg(q.options)
                                })
                            })
                        }
                        list = newArr
                    }else {
                        data = data.items.map(q => {
                            return {
                                url: q.cover,
                                ...q
                            }
                        })
                        list = data.filter(v => v.category && v.category.type === this.catalogType)
                    }
                }catch (e) {
                    console.log('获取搜索数据失败==>', e)
                }
                this.searchData = list

                this.isLoading = false
            },
        }
    }
</script>
